import { Routes, Route } from 'react-router-dom'
import { NavigateWithThread } from '../navigate-with-thread'
import { FocusDashboard } from '../focus-dashboard'

type AgencyFocus = 'client' | 'engineer' | 'principal'

interface AgencyRoutesProps {
  focus: AgencyFocus
  onStartConversation?: (message: string) => void
}

/** Thin homes for agency foci until dedicated dashboards exist. */
export function AgencyRoutes({ focus, onStartConversation }: AgencyRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard focus={focus} onStartConversation={onStartConversation} />
        }
      />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
